/* Rotating curated search examples without mutating any user input or search terms. */
function initLoftySearchExamples() {
  const fields = Array.from(document.querySelectorAll(".lc-header-search--field[data-lc-search-placeholders]"));
  if (!fields.length) return;

  const raw = fields[0].dataset.lcSearchPlaceholders || "";
  const terms = raw.split(/[,\n]/).map(term => term.trim()).filter(Boolean);
  if (!terms.length) return;

  const example = terms[Math.floor(Math.random() * terms.length)];
  const placeholder = `Try “${example}”`;

  for (const field of fields) {
    field.querySelectorAll("[data-lc-search-example]").forEach(element => {
      element.textContent = placeholder;
    });
  }
  // The modal remains the actual editable search field.
  const modalInput = document.querySelector("#search-modal .search-input");
  if (modalInput && !modalInput.value) modalInput.placeholder = placeholder;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLoftySearchExamples, { once: true });
} else {
  initLoftySearchExamples();
}
document.addEventListener("shopify:section:load", initLoftySearchExamples);
